// Motivational quote strip for the top of the Home page.
//
// ONE quote is picked at mount (i.e. per page load) from a static
// owner-curated list — deliberately no timers or cycling, so it costs nothing
// while the dashboard sits open. Refresh the page for a new one.

import { useState } from "react";

interface Quote {
  text: string;
  by: string;
}

// Owner-curated list — keep as-is; do not add song lyrics beyond the first
// line, which the owner supplied himself.
const QUOTES: Quote[] = [
  { text: "Overly focused, it's far from the time to rest now.", by: "Drake" },
  { text: "The work works on you more than you work on it.", by: "Alex Hormozi" },
  { text: "You can't lose if you don't quit.", by: "Alex Hormozi" },
  { text: "Do more of what already works.", by: "Alex Hormozi" },
  { text: "Confidence comes from a stack of undeniable proof.", by: "Alex Hormozi" },
  {
    text: "The person who asks is a fool for five minutes. The person who never asks is a fool for life.",
    by: "proverb",
  },
  {
    text: "You do not rise to the level of your goals. You fall to the level of your systems.",
    by: "James Clear",
  },
  { text: "Play long-term games with long-term people.", by: "Naval Ravikant" },
  { text: "Hard choices, easy life. Easy choices, hard life.", by: "Jerzy Gregorek" },
  { text: "Job's not finished.", by: "Kobe Bryant" },
  {
    text: "The best time to plant a tree was 20 years ago. The second best time is now.",
    by: "proverb",
  },
  { text: "Sell the vacation, not the flight.", by: "sales maxim" },
];

export function QuoteBanner() {
  // Lazy initializer → exactly one random pick per mount, stable across re-renders.
  const [quote] = useState<Quote>(() => QUOTES[Math.floor(Math.random() * QUOTES.length)]);
  return (
    <div className="quote-banner">
      <span className="quote-text">&ldquo;{quote.text}&rdquo;</span>
      <span className="quote-by">— {quote.by}</span>
    </div>
  );
}

export default QuoteBanner;
